import { IStoreState, IAdContent } from 'src/interface';

export const adNativeSelector = (zoneId: string) => (
    state: IStoreState
): IAdContent[] | null => {
    if (!state.ad.native) {
        return null;
    }

    return state.ad.native[zoneId];
};
export const isNoAdSeclector = (state: IStoreState): boolean =>
    state.ad?.isNoAd || false;
